import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    TopWrapperVideo,
    TopWrapperVideoContent,
    VideoContent,
    VideoPlayerWrapper,
    VideoWrapper
} from '../../style/VideoStyle';
import { VideoPlayer } from '../tournametns/player/ui/VideoPlayer';
import { FormWrapPopup, MainWrapper, TopWrapper } from '../../style/DasboardMain';
import Navigation from '../../components/Navigation/Navigation';
import LandingNavigation from '../../components/Navigation/LandingNavigation';
import IntroText from "../../components/introText/index";
import Button from '../../components/button';
import TextInput from '../../components/inputs/TextInput';
import Modal from "../../components/modal/index";
import { Dropdown, DropdownButton, DropdownContent, DropdownItem } from '../tournametns/player/ShotsPlayer';

import arrowIconUp from "../../images/up.svg";
import arrowIconDown from "../../images/down.svg";
import {$apiV1, VIDEO_SERVICE_URL} from '../../config/api';
import { VideoListPanel } from '../../components/playlist/VideoListPanel';
import { useLexicon } from '../../hooks/useLexicon';
import { trackPlaylistAction } from '../../tracking';

const Index = () => {
    const l = useLexicon();
    const { id } = useParams();

    const [playlist, setPlaylist] = useState(null);
    const [videoHref, setVideoHref] = useState('');
    const [videoSecond] = useState(0);
    const [loadingVideo, setLoadingVideo] = useState(false);

    const [openAddVideo, setOpenAddVide] = useState(false);
    const [folderName, setFolderName] = useState("");

    const [userPlaylists, setUserPlaylists] = useState([]);
    const [selectedPlaylist, setSelectedPlaylist] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [loadingAddPlaylist, setLoadingAddPlaylist] = useState(false);

    const [record, setRecord] = useState(null);
    const [recordTime, setRecordTime] = useState(null);

    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
    const [disabledNext, setDisabledNext] = useState(true);
    const [disabledPrev, setDisabledPrev] = useState(true);

    const isAuth = localStorage.getItem('token');

    useEffect(() => {
        const getUserPlaylists = async () => {
            try {
                const res = await $apiV1.get('/users/playlists');
                setUserPlaylists(res.data);
            } catch (e) {
                console.log('get user playlists err', e.message);
            }
        }

        getUserPlaylists();
    }, [])

    useEffect(() => {
        const getPlaylist = async (id, video_id) => {
            try {
                const response = await $apiV1.get(`users/shared_playlist/${id}`);
                setPlaylist(response.data);
                trackPlaylistAction({
                    action: 'open',
                    entityId: response?.data?.id || Number(id),
                    entityLabel: response?.data?.title || null,
                    entityType: 'shared_playlist',
                    metadata: {
                        videos_count: Array.isArray(response?.data?.videos) ? response.data.videos.length : 0,
                    },
                    sourceSurface: 'shared_playlist',
                });
                if (video_id) {
                    const existVideoIndex = response.data?.videos?.findIndex(item => item.id === video_id);
                    if (existVideoIndex >= 0) {
                        handlePlayVideo(response.data?.videos?.[existVideoIndex], existVideoIndex);
                    }
                }
            } catch (e) {
                console.log('get playlist error', e.message, e.response.data);
                alert(`Get playlist error: ${e?.response?.data?.message || e.message}`)
            }
        }
        id && getPlaylist(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    useEffect(() => {
        setDisabledPrev(currentVideoIndex === 0);
        setDisabledNext(currentVideoIndex >= playlist?.videos?.length - 1);
        // handlePlayVideo(videoSource);
    }, [currentVideoIndex, playlist]);

    const handleSelectChange = (value) => {
        setSelectedPlaylist(value);
    };

    const handleEmailChange = (newValue) => {
        setFolderName(newValue);
    };

    const addRecordToPlaylist = () => {
        setOpenAddVide(true);
    }

    const handlePrevVideo = () => {
        if (currentVideoIndex > 0) {
            handlePlayVideo(playlist?.videos?.[currentVideoIndex - 1]);
        }
    };

    const handleNextVideo = () => {
        if (currentVideoIndex < playlist?.videos?.length - 1) {
            handlePlayVideo(playlist?.videos?.[currentVideoIndex + 1]);
        }
    };

    const addNewFolder = async () => {
        try {
            setLoadingAddPlaylist(true);
            let playlist;

            if (!selectedPlaylist) {
                // First API request to create a new folder
                const createFolderResponse = await $apiV1.post(`/users/playlists`,
                    { title: folderName },
                );
                playlist = createFolderResponse.data;
                trackPlaylistAction({
                    action: 'create',
                    entityId: playlist?.id,
                    entityLabel: playlist?.title || folderName,
                    sourceSurface: 'playlist',
                });
                setUserPlaylists(prev => [...prev, playlist])
            } else {
                playlist = selectedPlaylist;
            }

            setOpenAddVide(!openAddVideo);

            if (record?.id && recordTime?.startTime && recordTime?.endTime) {
                const params = {
                    end_second: +(+recordTime.endTime).toFixed(0),
                    start_second: +(+recordTime.startTime).toFixed(0),
                    event_id: record.id,
                    title: `Record from ${recordTime.startTime.toFixed(0)} to ${recordTime.endTime.toFixed(0)}`
                }
                // await getCutVideo(params);
                await $apiV1.post(`/users/playlists/${playlist.id}/add`,
                    [params],
                );
                trackPlaylistAction({
                    action: 'video_add',
                    entityId: playlist?.id,
                    entityLabel: playlist?.title || null,
                    metadata: {
                        clip_end_second: params.end_second,
                        clip_start_second: params.start_second,
                        event_id: record?.id,
                        shared_playlist_id: Number(id),
                    },
                    sourceSurface: 'shared_playlist',
                });
                return
            }
        } catch (error) {
            console.error("Error processing request:", error);
        } finally {
            setLoadingAddPlaylist(false);
        }
    };

    const handlePlayVideo = async (video, idx) => {
        try {
            const video_idx = playlist?.videos?.findIndex(item => item.id === video.id);
            setCurrentVideoIndex(video_idx || idx || 0);

            if (video?.details?.video) {
                setLoadingVideo(true);
                setRecord(video);

                const url = `${VIDEO_SERVICE_URL}/cut`;
                const response = await fetch(url, {
                    body: JSON.stringify({
                        path: decodeURI(video?.details?.video),
                        start: video?.start_second,
                        end: video?.end_second
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    method: 'POST',
                });
                const json = await response.json();
                if (json.data && json.data.path) {
                    setVideoHref(json.data.path);
                    trackPlaylistAction({
                        action: 'video_play',
                        entityId: Number(id),
                        entityLabel: playlist?.title || null,
                        entityType: 'shared_playlist',
                        metadata: {
                            shared_playlist_id: Number(id),
                            video_id: video?.id,
                        },
                        sourceSurface: 'shared_playlist',
                    });
                }

                if (json.errors && json.errors.length) {
                    alert(`Errors: ${json.errors.join(" , ")}`)
                }
            }
        } catch (e) {
            alert(`Get video error, ${e.message}`);
            console.log('get cut video err', e.message);
        } finally {
            setLoadingVideo(false);
        }
    };

    const modal = (
        <Modal isOpen={openAddVideo} setIsOpen={setOpenAddVide} closeIc>
            <h1>
                {l(1027)}
            </h1>
            <FormWrapPopup style={{ marginTop: "20px" }}>
                <Dropdown>
                    <DropdownButton
                        onClick={() => setShowDropdown(!showDropdown)}
                    >
                        {!selectedPlaylist
                            ? l(1088)
                            : `${selectedPlaylist?.title}`}
                        <img src={showDropdown ? arrowIconUp : arrowIconDown} />
                    </DropdownButton>
                    <DropdownContent $show={showDropdown}>
                        {userPlaylists.map((item) => (
                            <DropdownItem
                                key={item.id}
                                selected={item.id === selectedPlaylist?.id}
                                onClick={() => handleSelectChange(item)}
                            >
                                {item.title}
                            </DropdownItem>
                        ))}
                    </DropdownContent>
                </Dropdown>
                <TextInput
                    label={l(1089)}
                    type={"text"}
                    value={folderName}
                    placeholder={l(1090)}
                    onChange={handleEmailChange}
                />
            </FormWrapPopup>
            <Button
                style={{ zIndex: 1 }}
                title={l(426)}
                size={"full"}
                onClick={() => addNewFolder()}
                disabled={loadingAddPlaylist}
            />
        </Modal>
    );

    return (
        <MainWrapper>
            {isAuth ? <Navigation /> : <LandingNavigation />}
            <VideoWrapper
                style={!isAuth ? { width: "100%", padding: 40 } : null}
                className={
                    localStorage.getItem("navigationOpen") === "true"
                        ? ""
                        : "fullWidthPage"
                }
            >
                <TopWrapper>
                    <IntroText title={`${l(125)} ${playlist?.title}`} />
                </TopWrapper>
                <VideoPlayerWrapper>
                    <VideoListPanel
                        handlePlayVideo={handlePlayVideo}
                        currentVideoIndex={currentVideoIndex}
                        playlist={playlist}
                    />

                    <VideoContent>
                        <VideoPlayer
                            video={videoHref}
                            toSecond={videoSecond}
                            playNextVideo={handleNextVideo}
                            playPrevVideo={handlePrevVideo}
                            videos={playlist?.videos || []}
                            loading={loadingVideo}
                            record={record}
                            setRecord={setRecord}
                            recordTime={recordTime}
                            setRecordTime={setRecordTime}
                            addRecordToPlaylist={addRecordToPlaylist}
                            disabledNext={disabledNext}
                            disabledPrev={disabledPrev}
                        />
                    </VideoContent>
                </VideoPlayerWrapper>
            </VideoWrapper>
            {modal}
        </MainWrapper>
    );
}

export default Index;
